<template>
	<h5><span class="prefix">Account:</span> {{ connectionName }}</h5>
</template>

<script>
export default {
	name: 'AccountHeader',
	props: { credentials: { type: Object } },
	computed: {
		connectionName() {
			return this.credentials?.connection_name;
		},
	},
};
</script>

<style lang="scss" scoped>
span.prefix {
	opacity: 0.5;
}
</style>
